import React, { Fragment } from "react";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import redirectBtnStyle from "./redirectBtn.style";
import Button from "@material-ui/core/Button";
import T, { translate } from "Translate";
import ToggleDisplay from "Common/ToggleDisplay";
import LoadingImage from "Common/Images/whiteLoading.gif";
import Locale from "Services/locale";
import sendEvent, { EVENT } from "Services/googleAnalytics";

const redirectBtn = props => {
    const { classes, locale, loginToken } = props;

    const shopUrl = React.useMemo(() => {
        let shopUrl = "";

        const translationLocale = Locale.getTranslationLocale(locale);

        if (loginToken) {
            shopUrl = translate("shop_now_url", { locale: translationLocale, loginToken: btoa(loginToken) });
        } else {
            shopUrl = translate("shop_now_url", { locale: translationLocale, loginToken: "" });
            shopUrl = shopUrl.replace("sl/", "home");
        }
        return shopUrl;
    }, [locale]);

    return (
        <Fragment>
            <ToggleDisplay if={loginToken !== null}>
                <Grid item xs={12}>
                    <Grid container justify="center">
                        <a
                            href={shopUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={classes.noHyper}
                            onClick={() => sendEvent(EVENT.BUTTON_CONGRATS_SHOP_NOW)}
                        >
                            <Button variant="outlined" size="large" className={classes.redirectBtn} data-testid="shop_now">
                                <T>shop_now</T>
                            </Button>
                        </a>
                    </Grid>
                </Grid>
            </ToggleDisplay>
            <ToggleDisplay if={loginToken === null}>
                <div className={classes.loading}>
                    <img
                        className={classes.img}
                        alt="loading"
                        src={LoadingImage}
                        style={{ width: "50px", height: "50px" }}
                    />
                </div>
            </ToggleDisplay>
        </Fragment>
    );
};

export default withStyles(redirectBtnStyle)(redirectBtn);



// WEBPACK FOOTER //
// ./src/components/SignUpSuccessContainer/SignUpSuccess/RedirectBtn/RedirectBtn.js